import { internalRoutes } from './internalRoutes';
import { publicRoutes } from './publicRoutes';

export const routes = [...publicRoutes, internalRoutes];
